import { Users } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import ComingSoonLayout from '../components/ComingSoonLayout';

/**
 * Handles both /roommates (Find roommates) and /roommates/matches.
 * Same placeholder for now with slightly different copy.
 */
const Roommates = () => {
  const { pathname } = useLocation();
  const isMatches = pathname.startsWith('/roommates/matches');
  return (
    <ComingSoonLayout
      icon={Users}
      headline={
        isMatches
          ? 'Roommate matches are coming soon.'
          : 'Roommate matching is coming soon.'
      }
      body={
        isMatches
          ? "We'll show you students with similar sleep schedules, cleanliness, budgets, and more — so you can find someone you'll actually enjoy living with."
          : "We'll match you with students who have similar lifestyles — so you can find someone you'll actually enjoy living with."
      }
      footnote="Fill out your Lifestyle section on Edit Profile to prep your match profile."
      testId="roommates-placeholder"
    />
  );
};

export default Roommates;
